import MuiTableBody from "@mui/material/TableBody";
const TableBody = MuiTableBody;
export default TableBody;
